import { BonusxProductsService } from "../../services/BonusProductsService/BonusxProductsService";

export const serviceApiService = new BonusxProductsService();
